<script>
    import Schema from 'async-validator'
    import to from 'await-to-js'

    export default {
        props: {
            model: {
                type: Object,
                default: () => ({})
            },
            rules: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                errors: {},
                isAuthorized: false,
            }
        },

        computed: {
            validator() {
                return new Schema(this.rules)
            }
        },

        mounted() {
            const props = Object.keys(this.rules)
            this.setErrorDefaults(props)
            this.createFieldWatchers(props)
            // Принимать серверные ошибки валидации для подсветки
            if (this.$root && this.$root.$on) {
                this.$root.$on('serverValidationErrors', this.applyServerErrors)
            }
        },

        beforeDestroy() {
            if (this.$root && this.$root.$off) {
                this.$root.$off('serverValidationErrors', this.applyServerErrors)
            }
        },

        methods: {
            createFieldWatchers(props) {
                for (const prop of props) {
                    this.$watch(`model.${prop}`, async () => {
                        const rule = { [prop]: this.rules[prop] }
                        const value = { [prop]: this.model[prop] }

                        const fieldValidator = new Schema(rule)
                        const [error] = await to(fieldValidator.validate(value))

                        const errorValue = { isValid: null, message: '' }

                        if (error) {
                            errorValue.isValid = false
                            errorValue.message = error.errors[0].message
                        } else {
                            errorValue.isValid = true
                            errorValue.message = ''
                        }

                        this.$set(this.errors, prop, errorValue)
                    })
                }
            },

            setErrorDefaults(props) {
                for (const prop of props) {
                    this.$set(this.errors, prop, { isValid: null, title: '' })
                }
            },

            async validate() {
                try {
                    await this.validator.validate(this.model)
                    return Promise.resolve()
                } catch (error) {
                    this.mapErrors(error)
                    return Promise.reject(error)
                }
            },

            reset() {
                this.setErrorDefaults()
            },

            mapErrors(error) {
                if (!('errors' in error)) {
                    throw error
                }

                for (const { field, message } of error.errors) {
                    this.errors[field] = { isValid: false, message }
                }
            },

            applyServerErrors(fieldErrorsMap) {
                if (!fieldErrorsMap || typeof fieldErrorsMap !== 'object') return
                Object.keys(fieldErrorsMap).forEach((field) => {
                    const message = fieldErrorsMap[field]
                    if (typeof message === 'string' && message.length) {
                        this.$set(this.errors, field, { isValid: false, message })
                    }
                })
            },
        },

        render(createElement) {
            if (!this.$scopedSlots.default) {
                return null
            }
            const slot = this.$scopedSlots.default({ errors: this.errors })
            return Array.isArray(slot) && slot.length > 1
                ? createElement('div', slot)
                : slot
        }
    }
</script>
